import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showTestUsers, setShowTestUsers] = useState(false);
  const { login, getTestUsers } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(username, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  const handleTestUserClick = (testUser) => {
    setUsername(testUser.username);
    setPassword(testUser.password);
  };

  const testUsers = getTestUsers();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-section">
            <span className="logo-icon">🏢</span>
            <h1>ASTOS ERP</h1>
          </div>
          <h2>Firma Yönetim Paneli</h2>
          <p>Güvenli giriş yapın</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Kullanıcı Adı</label>
            <div className="input-wrapper">
              <span className="input-icon">👤</span>
              <input
                type="text"
                className="form-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Kullanıcı adınızı girin"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Şifre</label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input
                type="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Şifrenizi girin"
                required
                disabled={loading}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary login-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="spinner-small"></div>
                Giriş yapılıyor...
              </>
            ) : (
              <>
                <span className="btn-icon">🚪</span>
                Giriş Yap
              </>
            )}
          </button>
        </form>

        <div className="test-users-section">
          <button 
            className="test-users-toggle"
            onClick={() => setShowTestUsers(!showTestUsers)}
          >
            <span className="toggle-icon">{showTestUsers ? '▼' : '▶'}</span>
            Test Kullanıcıları
          </button>
          
          {showTestUsers && (
            <div className="test-users-list">
              <p className="test-users-info">
                Geliştirme için test kullanıcıları. Her kullanıcının farklı yetkileri vardır.
              </p>
              <div className="test-users-grid">
                {testUsers.map((user, index) => (
                  <div 
                    key={index} 
                    className="test-user-card"
                    onClick={() => handleTestUserClick(user)}
                  >
                    <div className="test-user-header">
                      <span className="user-role-icon">
                        {user.role === 'admin' ? '👑' : 
                         user.role === 'manager' ? '👔' :
                         user.role === 'sales' ? '💰' :
                         user.role === 'warehouse' ? '📦' :
                         user.role === 'consultant' ? '👨‍💼' :
                         user.role === 'hr' ? '👥' :
                         user.role === 'production' ? '⚙️' :
                         user.role === 'b2b_user' ? '🏢' :
                         user.role === 'b2c_user' ? '🛒' : '👤'}
                      </span>
                      <span className="user-role">{user.role.toUpperCase()}</span>
                    </div>
                    <div className="test-user-info">
                      <div className="user-name">{user.name}</div>
                      <div className="user-credentials">
                        <span className="username">Kullanıcı: {user.username}</span>
                        <span className="password">Şifre: {user.password}</span>
                      </div>
                    </div>
                    <div className="test-user-action">
                      <span className="action-text">Tıkla ve Giriş Yap</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="login-footer">
          <div className="footer-info">
            <p>ASTOS ERP Sistemi v2.1.0</p>
            <p>Firma Yönetim Paneli</p>
          </div>
          <div className="footer-links">
            <a href="#" className="footer-link">Yardım</a>
            <a href="#" className="footer-link">İletişim</a>
            <a href="#" className="footer-link">Gizlilik</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 